/* Publish by EComposer at 2024-06-13 08:00:56*/
;
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gs834cie04d"]=  window.__ectimmers["ecom-gs834cie04d"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-gs834cie04d';
                    document.querySelectorAll('.ecom-gs834cie04d').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            